import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { fetchNotificationSettings } from "../service/settings";

export const fetchFeatureFlags = createAsyncThunk(
  "featureFlags/fetch",
  async (_, { rejectWithValue }) => {
    try {
      const response = await fetchNotificationSettings();
      return response.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

const featureFlagsSlice = createSlice({
  name: "featureFlags",
  initialState: {
    isExternalShareEnabled: false,
    isESignEnabled: false,
    isRemindEmailEnabled: false,
    loading: false,
    error: null,
  },
  reducers: {
    setFeatureFlags: (state, action) => {
      const { isExternalShareEnabled, isESignEnabled, isRemindEmailEnabled } =
        action.payload;

      state.isExternalShareEnabled = isExternalShareEnabled;
      state.isESignEnabled = isESignEnabled;
      state.isRemindEmailEnabled = isRemindEmailEnabled;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchFeatureFlags.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchFeatureFlags.fulfilled, (state, action) => {
        const email = action?.payload?.data?.email;

        state.isExternalShareEnabled = email?.external_share;
        state.isESignEnabled = email?.signature_request;
        state.isRemindEmailEnabled = email?.signature_reminder;
        state.loading = false;
      })
      .addCase(fetchFeatureFlags.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Failed to fetch feature flags";
      });
  },
});

export const { setFeatureFlags } = featureFlagsSlice.actions;
export default featureFlagsSlice.reducer;
